<div class="recovery-codes-dialog">

    <!-- Shared 2FA shield header (same shell as the gate, setup steps and verification dialog) -->
    <div class="dialog-header">
        <div class="shield-icon">
            <i class="ph-bold ph-shield-check" aria-hidden="true"></i>
        </div>
        <div class="dialog-title">Save your recovery codes</div>
        <div class="dialog-subtitle">
            Each code signs you in once if you lose access to your authenticator app or phone.
        </div>
    </div>

    <div class="dialog-body">
        <app-recovery-codes-panel
            [codes]="codes"
            (acknowledgedChange)="acknowledged = $event"></app-recovery-codes-panel>
    </div>

    <!-- A lone PRIMARY action sits right, pushed by flex-spacer — the v2 idiom for this exact
         shape (bookkeeping-internal-notes-dialog / -view-reports-dialog, both a lone "Done").
         A lone SECONDARY action (Cancel/Close) stays left instead. -->
    <div class="dialog-footer">
        <flex-spacer></flex-spacer>

        <button type="button"
                class="btn-done"
                e2eId="recovery-codes-done"
                [disabled]="!acknowledged"
                (click)="done()">
            {{ 'Done' }}
        </button>
    </div>
</div>
